/* ==========================================================================
   Bundle Builder — Page JS (bundle-builder-page.js)
   Products loaded via /products/{handle}.js to bypass all_products[] limit.
   v2 - 2026-03-24
   ========================================================================== */

(function () {
  'use strict';

  var DATA = window.BB_PAGE_DATA;

  if (!DATA) {
    return;
  }

  var maxSlots = DATA.maxSlots || 4;
  var tiers = DATA.tiers || [];
  var handles = DATA.handles || [];
  var moneyFormat = DATA.moneyFormat || '${{amount}}';

  /* ---- State ---- */
  var selectedItems = []; // { variantId, productId, handle, title, price, image }
  var loadedProducts = {}; // keyed by handle

  /* ---- DOM refs ---- */
  var page = document.getElementById('BundleBuilderPage');
  var grid = document.getElementById('bbProductGrid');
  var slotsContainer = document.getElementById('bbSlots');
  var addToCartBtn = document.getElementById('bbAddToCart');
  var mobileAddToCartBtn = document.getElementById('bbMobileAddToCart');
  var mobileFill = document.querySelector('[data-mobile-fill]');
  var mobileCounter = document.querySelector('[data-mobile-counter]');
  var mobilePrice = document.querySelector('[data-mobile-price]');
  var bundlePriceEl = document.querySelector('[data-bundle-price]');
  var statusEl = document.getElementById('bbStatus');
  var cartStatusEl = document.getElementById('bbCartStatus');

  if (!page || !grid) return;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ===========================================================
     H1 NORMALIZATION
     Convert any h1 inside this section that is NOT the bundle banner title
     to h2. Never rewrite headings owned by another page section.
     This mainly targets h1s injected by Shogun product descriptions.
     =========================================================== */
  (function normalizeH1s() {
    var allH1s = page.querySelectorAll('h1:not(.bundle-banner__title)');
    for (var i = 0; i < allH1s.length; i++) {
      var h1 = allH1s[i];
      var h2 = document.createElement('h2');
      // Copy all attributes (class, id, style, data-*, etc.)
      for (var a = 0; a < h1.attributes.length; a++) {
        h2.setAttribute(h1.attributes[a].name, h1.attributes[a].value);
      }
      h2.innerHTML = h1.innerHTML;
      h1.parentNode.replaceChild(h2, h1);
    }
  })();

  /* ===========================================================
     FORMAT MONEY
     =========================================================== */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    return (moneyFormat || '${{amount}}')
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount);
  }

  /* ===========================================================
     GET CURRENT TIER
     =========================================================== */
  function getCurrentTier(qty) {
    var active = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty) active = tiers[i];
    }
    return active;
  }

  /* ===========================================================
     COMPUTE BUNDLE PRICE
     - Tier discount from the bundle builder tiers
     - Subscribe price uses the actual selling plan adjustment per product
       (from BB_PAGE_DATA.sellingPlanAdjustments), falling back to 10%
     =========================================================== */
  var SUBSCRIBE_DISCOUNT_PCT_FALLBACK = 10;

  function isSubscribeChecked() {
    // Subscribe & Save is temporarily disabled — bundle builder is one-time purchase only.
    return false;
  }

  // Returns the item price adjusted for its selling plan (subscribe price).
  // Uses the exact adjustment Shopify will apply, not a hardcoded %.
  function getItemSubscribePrice(item) {
    var adj = DATA.sellingPlanAdjustments && DATA.sellingPlanAdjustments[item.handle];
    if (!adj) return Math.round(item.price * (100 - SUBSCRIBE_DISCOUNT_PCT_FALLBACK) / 100);
    if (adj.valueType === 'percentage') {
      return Math.round(item.price * (100 - adj.value) / 100);
    } else if (adj.valueType === 'fixed_amount') {
      return Math.max(0, item.price - adj.value);
    }
    // value_type === 'price' — adj.value IS the final price in cents
    return adj.value;
  }

  function computePrice() {
    var subtotal = 0;
    var subscribed = isSubscribeChecked();
    for (var i = 0; i < selectedItems.length; i++) {
      var item = selectedItems[i];
      subtotal += (subscribed && item.sellingPlanId) ? getItemSubscribePrice(item) : item.price;
    }
    var tier = getCurrentTier(selectedItems.length);
    if (tier) {
      subtotal = Math.round(subtotal * (100 - tier.pct) / 100);
    }
    return subtotal;
  }

  /* ===========================================================
     UPDATE UI
     =========================================================== */
  function updateUI() {
    var count = selectedItems.length;

    // --- SINGLE UNIFIED STATUS BAR ---
    if (statusEl) {
      var headingEl = document.getElementById('bbStatusHeading');
      var fillEl    = document.getElementById('bbStatusFill');
      var countEl   = document.getElementById('bbStatusCount');
      var barEl     = document.getElementById('bbStatusBar');
      var innerEl   = document.getElementById('bbStatusInner');

      var fillPct  = count === 0 ? 0 : count === 1 ? 30 : Math.min((count / maxSlots) * 100, 100);
      var complete = count >= maxSlots;

      // Find the next tier the user is working towards
      var activeTier = tiers[tiers.length - 1]; // default: last
      for (var t = 0; t < tiers.length; t++) {
        if (count < tiers[t].qty) { activeTier = tiers[t]; break; }
      }
      var lastReachedTier = null;
      for (var t = 0; t < tiers.length; t++) {
        if (count >= tiers[t].qty) lastReachedTier = tiers[t];
      }

      // Fill width
      if (fillEl) fillEl.style.width = fillPct + '%';

      // Count label
      if (countEl) countEl.textContent = count + ' of ' + maxSlots;
      if (barEl) barEl.setAttribute('aria-valuenow', String(count));

      // Bar color: green when max slots reached, blue otherwise
      if (barEl) barEl.classList.toggle('is-complete', complete);

      // Position inner centered on the fill (or centered in bar if fill = 0)
      if (innerEl && barEl) {
        var barW  = barEl.offsetWidth;
        var fillW = barW * (fillPct / 100);
        var innerW = innerEl.offsetWidth;
        var centerX;
        if (fillW < 1) {
          // No fill yet — center in bar
          centerX = barW / 2;
        } else {
          // Center within the fill
          centerX = fillW / 2;
        }
        innerEl.style.left  = (centerX - innerW / 2) + 'px';
        innerEl.style.width = innerW + 'px';
      }

      // Heading text
      if (headingEl) {
        if (complete) {
          headingEl.textContent = '\uD83C\uDF89 Congrats! You\'re Saving ' + (lastReachedTier ? lastReachedTier.pct : activeTier.pct) + '%';
          headingEl.classList.add('is-complete');
        } else {
          var needed = activeTier.qty - count;
          headingEl.textContent = (needed === 1 ? 'Add 1 more' : 'Add ' + needed) + ' to Save ' + activeTier.pct + '%';
          headingEl.classList.remove('is-complete');
        }
      }
    }

    // Slots
    var slots = slotsContainer ? slotsContainer.querySelectorAll('.bb-aside__slot') : [];
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var thumb = slot.querySelector('.bb-aside__slot-thumb');
      var text = slot.querySelector('.bb-aside__slot-text');
      var badgesWrap = slot.querySelector('.bb-aside__slot-badges');
      var removeBtn = slot.querySelector('[data-action="remove-slot"]');

      if (i < count) {
        var item = selectedItems[i];
        slot.classList.add('is-filled');
        if (thumb) thumb.style.backgroundImage = 'url(' + item.image + ')';
        if (text) text.textContent = item.title;
        if (removeBtn) {
          removeBtn.classList.remove('cart--hidden');
          removeBtn.setAttribute('aria-label', 'Remove ' + item.title + ' from bundle');
        }

        // Build badges HTML for the slot (no price, no stars)
        if (badgesWrap) {
          var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[item.handle]) || {};
          var _slotBadges = '';

          // Info badges
          if (meta.infoBadges && meta.infoBadges.length) {
            var _ib = meta.infoBadges.filter(function (b) { return b && b.trim() !== '' && !/serving|fat.?loss/i.test(b); });
            if (_ib.length) {
              _slotBadges += '<div class="grid-product__info-badges">'
                + _ib.map(function (b) { return '<span class="grid-product__info-badge">' + escapeHTML(b.trim()) + '</span>'; }).join('')
                + '</div>';
            }
          }

          // Info highlights
          if (meta.infoHighlights && meta.infoHighlights.length) {
            var _badgeSet = (meta.infoBadges || []).map(function (b) { return b.trim().toUpperCase(); });
            var _hl = meta.infoHighlights.filter(function (h) { return h && h.trim() !== '' && _badgeSet.indexOf(h.trim().toUpperCase()) === -1; });
            if (_hl.length) {
              _slotBadges += '<div class="grid-product__info-highlights">'
                + _hl.map(function (h) { return '<span class="grid-product__info-highlight">' + escapeHTML(h.trim()) + '</span>'; }).join('')
                + '</div>';
            }
          }

          // Preset badges
          if (meta.badgeMostPopular || meta.badgeBestSeller || meta.badgeNewIn || meta.badgeBestValue) {
            _slotBadges += '<div class="grid-product__preset-badges">';
            if (meta.badgeMostPopular) _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--most-popular">MOST POPULAR CHOICE</span>';
            if (meta.badgeBestSeller)  _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--best-seller">BEST SELLER</span>';
            if (meta.badgeNewIn)       _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--new-in">NEW IN</span>';
            if (meta.badgeBestValue)   _slotBadges += '<span class="grid-product__preset-badge grid-product__preset-badge--best-value">BEST VALUE</span>';
            _slotBadges += '</div>';
          }

          badgesWrap.innerHTML = _slotBadges;
        }
      } else {
        slot.classList.remove('is-filled');
        if (thumb) thumb.style.backgroundImage = '';
        if (text) text.textContent = 'Select a product';
        if (badgesWrap) badgesWrap.innerHTML = '';
        if (removeBtn) {
          removeBtn.classList.add('cart--hidden');
          removeBtn.setAttribute('aria-label', 'Remove from bundle');
        }
      }
    }

    // Price
    var total = computePrice();
    var priceStr = formatMoney(total);
    if (bundlePriceEl) bundlePriceEl.textContent = priceStr;
    if (mobilePrice) mobilePrice.textContent = priceStr;

    if (mobileCounter) mobileCounter.textContent = count + '/' + maxSlots;
    if (mobileFill) mobileFill.style.width = (count === 0 ? 0 : count === 1 ? 30 : Math.min((count / maxSlots) * 100, 100)) + '%';

    var minTierQty = tiers.length > 0 ? tiers[0].qty : 2;
    // Optional per-template override (section setting "min_items"); default keeps the first-tier minimum.
    var pageEl = document.getElementById('BundleBuilderPage');
    var minItemsAttr = pageEl ? parseInt(pageEl.getAttribute('data-min-items'), 10) : NaN;
    var minItems = minItemsAttr > 0 ? minItemsAttr : minTierQty;
    var canAdd = count >= minItems;
    if (addToCartBtn) addToCartBtn.disabled = !canAdd;
    if (mobileAddToCartBtn) mobileAddToCartBtn.disabled = !canAdd;

    var ctaLabel = addToCartBtn ? addToCartBtn.querySelector('.bb-aside__cta-label') : null;
    if (ctaLabel && !addToCartBtn.disabled) {
      ctaLabel.textContent = 'PURCHASE ONE TIME';
    }
  }

  /* ===========================================================
     HELPERS
     =========================================================== */
  function escapeHTML(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function escapeAttr(str) {
    return String(str).replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  /* ===========================================================
     BUILD CARD HTML from product JSON
     =========================================================== */
  function buildCardHTML(product) {
    var handle = product.handle;
    var img = product.featured_image || (product.images && product.images[0] && product.images[0].src) || '';
    var imgSrc = img ? (img.split('?')[0] + '?width=500') : '';
    var price = product.price_min || (product.variants[0] && product.variants[0].price) || 0;
    var compareAt = product.compare_at_price_min || product.compare_at_price || 0;
    var availableVariants = product.variants.filter(function (v) { return v.available; });

    var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[handle]) || {};
    var displayName = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;

    var addBtnHTML = '';
    if (availableVariants.length === 0) {
      addBtnHTML = '<span class="bb-card__sold-out">Sold out</span>';
    } else {
      // Determine if the product has a pack/size option (non-flavour option with multiple values).
      // If it does → always add the single item directly (no dropdown).
      // If it only has flavour variants → show a flavour dropdown on the card.
      var hasPackOption = false;
      var opts = product.options || [];
      for (var _oi = 0; _oi < opts.length; _oi++) {
        var _oName = (typeof opts[_oi] === 'object' && opts[_oi] !== null) ? (opts[_oi].name || '') : String(opts[_oi]);
        if (!isFlavourOption(_oName)) {
          // Check if this non-flavour option actually has more than one unique value
          var _seen = {};
          for (var _vi = 0; _vi < product.variants.length; _vi++) {
            _seen[product.variants[_vi]['option' + (_oi + 1)]] = true;
          }
          if (Object.keys(_seen).length > 1) { hasPackOption = true; break; }
        }
      }

      if (hasPackOption) {
        // Has pack/size variants → add single item directly, no dropdown
        var singleVariant = pickSingleItemVariant(product, flavourOptionIndex(product), null);
        var vid = singleVariant ? singleVariant.id : availableVariants[0].id;
        addBtnHTML = '<button class="bb-card__add-btn" type="button" data-action="add-direct" data-variant-id="' + vid + '" aria-label="Add ' + escapeAttr(displayName) + ' to bundle">'
          + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
          + '<span class="bb-card__add-label">Add to bundle</span></button>';
      } else if (availableVariants.length === 1 || (product.variants.length === 1)) {
        // Single variant only → add directly
        var vid = availableVariants[0].id;
        addBtnHTML = '<button class="bb-card__add-btn" type="button" data-action="add-direct" data-variant-id="' + vid + '" aria-label="Add ' + escapeAttr(displayName) + ' to bundle">'
          + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
          + '<span class="bb-card__add-label">Add to bundle</span></button>';
      } else {
        // Only flavour variants → show flavour dropdown on card
        var optionBtns = availableVariants.map(function (v) {
          return '<button class="bb-card__variant-btn" type="button" data-action="add-direct" data-variant-id="' + v.id + '" aria-label="Add ' + escapeAttr(displayName) + ', ' + escapeAttr(v.title) + ' to bundle">' + escapeHTML(v.title) + '</button>';
        }).join('');
        addBtnHTML = '<div class="bb-card__variant-panel" data-variant-panel>'
          + '<button class="bb-card__variant-trigger" type="button" data-variant-trigger aria-expanded="false" aria-label="Choose an option for ' + escapeAttr(displayName) + '">'
          + '<svg class="bb-card__add-icon" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>'
          + '</button>'
          + '<div class="bb-card__variant-options" data-variant-options>' + optionBtns + '</div>'
          + '</div>';
      }
    }

    // ---- Loox stars ----
    var looxHtml = '';
    if (meta.looxRating && meta.looxRaters) {
      looxHtml = '<div class="grid-product__loox">'
        + '<div class="loox-rating loox-stars" data-id="' + meta.looxId + '" data-rating="' + meta.looxRating + '" data-raters="' + meta.looxRaters + '"></div>'
        + '</div>';
    }

    // ---- Info badges (from custom.info_badges metafield) — skip servings & fat-loss badges ----
    var infoBadgesHtml = '';
    if (meta.infoBadges && meta.infoBadges.length) {
      var badgeItems = meta.infoBadges.filter(function (b) {
        return b && b.trim() !== '' && !/serving|fat.?loss/i.test(b);
      });
      if (badgeItems.length) {
        infoBadgesHtml = '<div class="grid-product__info-badges">'
          + badgeItems.map(function (b) { return '<span class="grid-product__info-badge">' + escapeHTML(b.trim()) + '</span>'; }).join('')
          + '</div>';
      }
    }

    // ---- Info highlights (from custom.info_highlights metafield) ----
    var infoHighlightsHtml = '';
    if (meta.infoHighlights && meta.infoHighlights.length) {
      var badgeSet = (meta.infoBadges || []).map(function (b) { return b.trim().toUpperCase(); });
      var hlItems = meta.infoHighlights.filter(function (h) {
        return h && h.trim() !== '' && badgeSet.indexOf(h.trim().toUpperCase()) === -1;
      });
      if (hlItems.length) {
        infoHighlightsHtml = '<div class="grid-product__info-highlights">'
          + hlItems.map(function (h) { return '<span class="grid-product__info-highlight">' + escapeHTML(h.trim()) + '</span>'; }).join('')
          + '</div>';
      }
    }

    // ---- Preset badges (from individual boolean metafields, exact same as PLP) ----
    var presetBadgesHtml = '';
    if (meta.badgeMostPopular || meta.badgeBestSeller || meta.badgeNewIn || meta.badgeBestValue) {
      presetBadgesHtml = '<div class="grid-product__preset-badges">';
      if (meta.badgeMostPopular) presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--most-popular">MOST POPULAR CHOICE</span>';
      if (meta.badgeBestSeller)  presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--best-seller">BEST SELLER</span>';
      if (meta.badgeNewIn)       presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--new-in">NEW IN</span>';
      if (meta.badgeBestValue)   presetBadgesHtml += '<span class="grid-product__preset-badge grid-product__preset-badge--best-value">BEST VALUE</span>';
      presetBadgesHtml += '</div>';
    }

    // Preset badges first, then celeste (info) badges last
    var badgeRowHtml = (presetBadgesHtml || infoHighlightsHtml || infoBadgesHtml)
      ? '<div class="grid-product__badge-row">' + presetBadgesHtml + infoHighlightsHtml + infoBadgesHtml + '</div>'
      : '';

    // ---- Price ----
    var priceHtml = '<div class="grid-product__price">';
    if (compareAt && compareAt > price) {
      priceHtml += '<span class="grid-product__price--original">' + formatMoney(compareAt) + '</span>'
        + '<span class="sale-price">' + formatMoney(price) + '</span>';
    } else {
      priceHtml += '<span>' + formatMoney(price) + '</span>';
    }
    priceHtml += '</div>';

    var metaHtml = '<div class="grid-product__meta">'
      + looxHtml
      + '<div class="grid-product__title">' + escapeHTML(displayName) + '</div>'
      + badgeRowHtml
      + priceHtml
      + '</div>';

    return '<div class="bb-card__img-wrap">'
      + (imgSrc ? '<button class="bb-card__image-open" type="button" data-action="read-more" aria-label="View details for ' + escapeAttr(displayName) + '"><img class="bb-card__img" src="' + imgSrc + '" alt="" loading="lazy" width="500" height="500" decoding="async"></button>' : '')
      + addBtnHTML
      + '</div>'
      + '<div class="bb-card__info">'
      + metaHtml
      + '<button class="bb-card__read-more" type="button" data-action="read-more" data-href="/products/' + handle + '" aria-label="Learn more about ' + escapeAttr(displayName) + '">Learn more</button>'
      + '</div>';
  }

  /* ===========================================================
     LOAD PRODUCTS via /products/{handle}.js
     =========================================================== */
  function loadProduct(handle) {
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(shopRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        loadedProducts[handle] = product;

        var card = grid.querySelector('.bb-card[data-product-handle="' + handle + '"]');
        if (!card) return;

        card.classList.remove('bb-card--loading');
        card.setAttribute('data-product-id', product.id);
        var _customTitle = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;
        card.setAttribute('data-product-title', escapeAttr(_customTitle));
        card.setAttribute('data-product-price', product.price_min || product.variants[0].price);
        card.setAttribute('data-product-image', product.featured_image || (product.images[0] && product.images[0].src) || '');
        card.setAttribute('data-variants-json', JSON.stringify(product.variants));
        card.innerHTML = buildCardHTML(product);
      })
      .catch(function (err) {
        var card = grid.querySelector('.bb-card[data-product-handle="' + handle + '"]');
        if (card) card.style.display = 'none';
      });
  }

  /* ===========================================================
     ADD ITEM
     =========================================================== */
  function addToBundle(variantId, card) {
    if (selectedItems.length >= maxSlots) return;

    var title = card.getAttribute('data-product-title') || '';
    var price = parseInt(card.getAttribute('data-product-price'), 10) || 0;
    var image = card.getAttribute('data-product-image') || '';
    var handle = card.getAttribute('data-product-handle') || '';

    try {
      var variants = JSON.parse(card.getAttribute('data-variants-json') || '[]');
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          price = variants[i].price;
          if (variants[i].featured_image && variants[i].featured_image.src) image = variants[i].featured_image.src;
          break;
        }
      }
    } catch (e) { /* ignore */ }

    /* Resolve the selling plan for this product from the server-rendered map.
       /products/{handle}.js does NOT include selling_plan_groups, so we read
       the first selling plan ID from BB_PAGE_DATA.sellingPlans which is built
       from Liquid's product.selling_plan_groups[0].selling_plans[0].id. */
    var sellingPlanId = null;
    if (DATA.sellingPlans && DATA.sellingPlans[handle]) {
      sellingPlanId = DATA.sellingPlans[handle];
    }

    selectedItems.push({
      variantId: variantId,
      handle: handle,
      title: title,
      price: price,
      image: image,
      sellingPlanId: sellingPlanId
    });
    card.setAttribute('data-variant-id-selected', variantId);
    card.classList.add('is-selected');

    var panel = card.querySelector('[data-variant-panel]');
    if (panel) {
      panel.classList.remove('is-open');
      var panelTrigger = panel.querySelector('[data-variant-trigger]');
      if (panelTrigger) {
        panelTrigger.setAttribute('aria-expanded', 'false');
        panelTrigger.focus();
      }
    }

    updateUI();
  }

  /* ===========================================================
     REMOVE ITEM
     =========================================================== */
  function removeFromBundle(filledIndex) {
    if (filledIndex < 0 || filledIndex >= selectedItems.length) return;
    var removed = selectedItems.splice(filledIndex, 1)[0];
    if (removed) {
      var card = grid.querySelector('.bb-card[data-variant-id-selected="' + removed.variantId + '"]');
      if (card) {
        card.removeAttribute('data-variant-id-selected');
        card.classList.remove('is-selected');
      }
    }
    updateUI();
  }

  /* ===========================================================
     ADD TO CART
     Detects whether ANY cart drawer is present in the DOM.
     Both the native theme drawer (snippets/cart-drawer.liquid) and
     the upnova-like drawer (snippets/cart-drawer-upnova-like.liquid)
     use the same data-drawer="drawer-cart" attribute, so one check
     covers both scenarios.

     - Drawer found  → POST /cart/add.js, dispatch ajaxProduct:added
                       so Motion opens the drawer & rebuilds items.
     - No drawer     → POST /cart/add.js, then redirect to /cart.
     =========================================================== */

  function cartDrawerIsActive() {
    // Motion theme: cart drawer has id="CartDrawer" and only exists in
    // the DOM when settings.cart_type == 'drawer'
    return !!document.querySelector('#CartDrawer');
  }

  function openCartDrawer() {
    // Motion theme uses theme.Drawers — trigger via the cart icon click
    // which fires drawerOpen + drawerOpen.CartDrawer events internally.
    var toggle = document.querySelector('.js-drawer-open-cart');
    if (toggle) {
      toggle.click();
      return;
    }
    // Fallback: dispatch Motion's drawerOpen.CartDrawer event directly
    document.dispatchEvent(new CustomEvent('drawerOpen.CartDrawer'));
  }

  /* ===========================================================
     BUNDLE ID — unique per "add bundle" action so all items
     in this bundle can be identified as a group in the cart.
     Used by Shopify Discount Functions to target only bundle
     items (via the _bundle_item / _bundle_id line properties).
     =========================================================== */
  function generateBundleId() {
    return 'bb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
  }

  function addBundleToCart() {
    if (selectedItems.length === 0) return;

    // Determine active tier & discount %
    var activeTier = getCurrentTier(selectedItems.length);
    var discountPct = activeTier ? activeTier.pct : 0;

    // Is Subscribe & Save active?
    var wantsSubscription = isSubscribeChecked();

    // Generate a shared bundle ID for this group of items.
    // The Shopify Discount Function reads _bundle_item and
    // _bundle_id to group items and apply the correct tier %
    // only to these line items, ignoring everything else in
    // the cart.
    var bundleId = generateBundleId();

    // Build cart items
    var itemsToAdd = [];
    var seen = {};
    selectedItems.forEach(function (item) {
      var id = parseInt(item.variantId, 10);
      if (seen[id]) {
        seen[id].quantity += 1;
      } else {
        var entry = {
          id: id,
          quantity: 1,
          properties: {
            '_bundle_item': 'true',
            '_bundle_id': bundleId
          }
        };
        // When subscribe is checked and the product has a selling plan,
        // attach it so Shopify creates a subscription line item.
        if (wantsSubscription && item.sellingPlanId) {
          entry.selling_plan = item.sellingPlanId;
        }
        seen[id] = entry;
        itemsToAdd.push(entry);
      }
    });

    // A single product (allowed only when the section's min_items is 1) is added
    // as a normal line at regular price, not as a one-item bundle.
    if (selectedItems.length === 1) {
      itemsToAdd.forEach(function (entry) { delete entry.properties; });
    }

    var ctaLabel = addToCartBtn ? addToCartBtn.querySelector('.bb-aside__cta-label') : null;
    if (addToCartBtn) { addToCartBtn.disabled = true; }
    if (ctaLabel) { ctaLabel.textContent = 'Adding\u2026'; }
    if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = true; }

    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (cartStatusEl) cartStatusEl.textContent = 'Adding your bundle to the cart.';
    if (addToCartBtn) addToCartBtn.setAttribute('aria-busy', 'true');
    if (mobileAddToCartBtn) mobileAddToCartBtn.setAttribute('aria-busy', 'true');

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/add failed: ' + res.status);
      // No need to fetch /cart.js here — the MutationObserver in
      // bundle-builder-cart.js will call fetchCartAndSync() after
      // Motion finishes buildCart(), which fetches it once.
      return res.json();
    })
    .then(function () {
      if (ctaLabel) { ctaLabel.textContent = 'PURCHASE ONE TIME'; }
      if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.removeAttribute('aria-busy'); }
      if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = false; mobileAddToCartBtn.removeAttribute('aria-busy'); }
      if (cartStatusEl) cartStatusEl.textContent = 'Your bundle was added to the cart.';

      if (cartDrawerIsActive()) {
        // Cloak [data-products] before Motion re-renders it so bundle items
        // never flash as individual rows. bundle-builder-cart.js removes the
        // cloak once groupBundleItems has hidden the rows.
        var productsEl = document.querySelector('[data-products]');
        if (productsEl) {
          productsEl.classList.add('bb-cloaked');
          // Safety net: always uncloak after 3s in case something goes wrong
          setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 3000);
        }

        // Motion's CartDrawer listens for ajaxProduct:added to call
        // buildCart() (re-renders items from server) + open() the drawer.
        // buildCart() finishes → DOM mutation → MutationObserver →
        // single fetchCartAndSync() → single /cart.js fetch.
        var cartForm = document.querySelector('#CartDrawerForm') || document.body;
        cartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      } else {
        window.location.href = shopRoot + 'cart';
      }
    })
    .catch(function (err) {
      if (ctaLabel) { ctaLabel.textContent = 'Error \u2014 try again'; }
      if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.removeAttribute('aria-busy'); }
      if (mobileAddToCartBtn) { mobileAddToCartBtn.disabled = false; mobileAddToCartBtn.removeAttribute('aria-busy'); }
      if (cartStatusEl) cartStatusEl.textContent = 'We could not add the bundle. Please try again.';
    });
  }

  /* ===========================================================
     PRODUCT MODAL — dynamic "Learn More" overlay
     Fetches full product data from /products/{handle}.js,
     populates image gallery, variants, description, price.
     =========================================================== */
  var modal = document.getElementById('bbProductModal');
  var modalTitle = document.getElementById('bbModalTitle');
  var modalPrice = document.getElementById('bbModalPrice');
  var modalComparePrice = document.getElementById('bbModalComparePrice');
  var modalDiscountTag = document.getElementById('bbModalDiscountTag');
  var modalVariants = document.getElementById('bbModalVariants');
  var modalMainCarousel = document.getElementById('bbModalMainCarousel');
  var modalPrevBtn = document.getElementById('bbModalPrev');
  var modalNextBtn = document.getElementById('bbModalNext');
  var modalDots = document.getElementById('bbModalDots');
  var _slideCount = 0;
  var modalMainTrack = document.getElementById('bbModalMainTrack');
  var modalThumbTrack = document.getElementById('bbModalThumbTrack');
  var modalDescription = document.getElementById('bbModalDescription');
  var modalAddBtn = document.getElementById('bbModalAddBtn');

  var _modalProduct = null;    // current product JSON
  var _modalVariantId = null;  // currently selected variant ID
  var _modalHandle = null;
  var _modalReturnFocus = null;

  function openModal(handle) {
    if (!modal) return;
    _modalHandle = handle;

    var product = loadedProducts[handle];
    if (!product) return;

    _modalProduct = product;
    _modalReturnFocus = document.activeElement;

    // ---- Title ----
    var _modalDisplayName = (BB_PAGE_DATA.customNames && BB_PAGE_DATA.customNames[handle]) || product.title;
    if (modalTitle) modalTitle.textContent = _modalDisplayName;

    // ---- Pick first available variant — always the single item (lowest price) ----
    // If the product has a flavour option, pick the single-item variant of the
    // first available flavour value. Otherwise just pick the cheapest available.
    var flavIdx = flavourOptionIndex(product);
    var defaultFlavVal = null;
    if (flavIdx >= 0) {
      // find first available flavour value
      for (var _fi = 0; _fi < product.variants.length; _fi++) {
        if (product.variants[_fi].available) {
          defaultFlavVal = product.variants[_fi]['option' + (flavIdx + 1)];
          break;
        }
      }
      if (!defaultFlavVal && product.variants.length) {
        defaultFlavVal = product.variants[0]['option' + (flavIdx + 1)];
      }
    }
    var firstVariant = pickSingleItemVariant(product, flavIdx, defaultFlavVal);
    _modalVariantId = firstVariant ? firstVariant.id : null;

    // ---- Images ----
    // Start gallery at the variant's featured image if available, otherwise slide 0
    var _openGalleryIdx = 0;
    if (firstVariant && firstVariant.featured_image && firstVariant.featured_image.position) {
      _openGalleryIdx = firstVariant.featured_image.position - 1;
    }
    populateGallery(product.images, _openGalleryIdx);

    // ---- Variants ----
    populateVariants(product, firstVariant);

    // ---- Price ----
    updateModalPrice(firstVariant);

    // ---- Discount tag ----
    updateModalDiscountTag();

    // ---- Description (from block settings) ----
    if (modalDescription) {
      var descData = (BB_PAGE_DATA.productDescriptions || {})[handle];
      var meta = (BB_PAGE_DATA.productMeta && BB_PAGE_DATA.productMeta[handle]) || {};
      var hasDesc = descData && descData.description;
      var hasRating = meta.looxRating && meta.looxRaters;

      if (hasDesc || hasRating) {
        var descHtml = '';

        // Rating stars (replaces old heading)
        if (hasRating) {
          descHtml += '<div class="bb-modal__desc-rating">'
            + '<div class="loox-rating loox-stars" data-id="' + meta.looxId + '" data-rating="' + meta.looxRating + '" data-raters="' + meta.looxRaters + '"></div>'
            + '</div>';
        }

        if (hasDesc) {
          // Convert <p> blocks that contain ✦ bullets into <ul><li> lists.
          var _desc = descData.description
            .replace(/✦\s*/g, '\x00')
            .replace(/<p>([\s\S]*?)<\/p>/g, function(match, inner) {
              if (inner.indexOf('\x00') === -1) return match;
              var lines = inner.split(/\x00|<br\s*\/?>/i)
                .map(function(l) { return l.trim(); })
                .filter(function(l) { return l.length > 0; });
              return '<ul>' + lines.map(function(l) { return '<li>' + l + '</li>'; }).join('') + '</ul>';
            });
          descHtml += '<div class="bb-modal__desc-body">' + _desc + '</div>';
        }
        modalDescription.innerHTML = descHtml;
        modalDescription.style.display = '';

        // Re-trigger Loox to render the stars inside the modal
        if (hasRating && window.loox) {
          try { window.loox.init(); } catch(_e) {}
        }
      } else {
        modalDescription.innerHTML = '';
        modalDescription.style.display = 'none';
      }
    }

    // ---- Show ----
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (modalTitle) requestAnimationFrame(function () { modalTitle.focus(); });
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (_slideObserver) { _slideObserver.disconnect(); _slideObserver = null; }
    _modalProduct = null;
    _modalVariantId = null;
    _modalHandle = null;
    if (_modalReturnFocus && typeof _modalReturnFocus.focus === 'function') _modalReturnFocus.focus();
    _modalReturnFocus = null;
  }

  /* Gallery — scroll-snap based dual carousel */
  var _activeSlideIdx = 0;
  var _slideObserver = null;

  function _getSlideId(idx) {
    var handle = _modalHandle || 'modal';
    return 'bbSlide-' + handle + '-' + idx;
  }

  function populateGallery(images, activeIndex) {
    if (!modalMainCarousel || !modalThumbTrack) return;

    _activeSlideIdx = activeIndex || 0;

    // Tear down previous observer
    if (_slideObserver) { _slideObserver.disconnect(); _slideObserver = null; }

    _slideCount = images ? images.length : 0;
    _renderGalleryNav();

    if (!images || images.length === 0) {
      modalMainCarousel.innerHTML = '';
      modalThumbTrack.innerHTML = '';
      return;
    }

    // ---- Build main carousel slides (directly in carousel, no wrapper track) ----
    var mainHTML = '';
    for (var i = 0; i < images.length; i++) {
      var src = images[i];
      if (typeof src === 'object') src = src.src || src;
      var bigSrc = src.split('?')[0] + '?width=600';
      var slideId = 'bbSlide-' + (_modalHandle || 'modal') + '-' + i;
      mainHTML += '<div class="bb-modal__main-slide" id="' + slideId + '" data-slide-idx="' + i + '">'
        + '<img src="' + bigSrc + '" alt="' + escapeAttr(_modalProduct ? _modalProduct.title : '') + ' - Image ' + (i + 1) + '" loading="lazy" decoding="async" width="600" height="600">'
        + '</div>';
    }
    modalMainCarousel.innerHTML = mainHTML;

    // ---- Build thumbnails ----
    var thumbsHTML = '';
    for (var t = 0; t < images.length; t++) {
      var tsrc = images[t];
      if (typeof tsrc === 'object') tsrc = tsrc.src || tsrc;
      var thumbSrc = tsrc.split('?')[0] + '?width=100';
      var cls = 'bb-modal__thumb-btn' + (t === _activeSlideIdx ? ' is-active' : '');
      thumbsHTML += '<button class="' + cls + '" type="button" data-thumb-idx="' + t + '" aria-label="View image ' + (t + 1) + ' of ' + images.length + '" aria-pressed="' + (t === _activeSlideIdx ? 'true' : 'false') + '">'
        + '<img src="' + thumbSrc + '" alt="" loading="lazy" decoding="async" width="100" height="100">'
        + '</button>';
    }
    modalThumbTrack.innerHTML = thumbsHTML;

    // ---- Jump to initial slide instantly (no animation on open) ----
    requestAnimationFrame(function () {
      var target = document.getElementById(_getSlideId(_activeSlideIdx));
      if (target) {
        // Instant scroll — temporarily disable smooth snap
        modalMainCarousel.style.scrollBehavior = 'auto';
        modalMainCarousel.scrollTop = target.offsetTop;
        requestAnimationFrame(function () {
          modalMainCarousel.style.scrollBehavior = '';
        });
      }
    });

    // ---- IntersectionObserver — sync thumb when user wheel-scrolls ----
    _slideObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.5) {
          var idx = parseInt(entry.target.getAttribute('data-slide-idx'), 10);
          if (idx !== _activeSlideIdx) {
            _activeSlideIdx = idx;
            _syncActiveThumbs(idx);
          }
        }
      });
    }, { root: modalMainCarousel, threshold: 0.5 });

    var slides = modalMainCarousel.querySelectorAll('.bb-modal__main-slide');
    for (var s = 0; s < slides.length; s++) {
      _slideObserver.observe(slides[s]);
    }
  }

  /** Sync active class on thumbs and scroll thumb strip */
  function _syncActiveThumbs(idx) {
    _updateGalleryNav(idx);
    if (!modalThumbTrack) return;
    var allThumbs = modalThumbTrack.querySelectorAll('.bb-modal__thumb-btn');
    for (var j = 0; j < allThumbs.length; j++) {
      allThumbs[j].classList.toggle('is-active', j === idx);
      allThumbs[j].setAttribute('aria-pressed', j === idx ? 'true' : 'false');
    }
    var activeThumb = allThumbs[idx];
    if (activeThumb) {
      var thumbCarousel = document.getElementById('bbModalThumbCarousel');
      if (thumbCarousel) {
        thumbCarousel.scrollTo({ top: activeThumb.offsetTop, left: activeThumb.offsetLeft, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }
  }

  /** Mobile swipe arrows + dots: build for the current product */
  function _renderGalleryNav() {
    var multi = _slideCount > 1;
    if (modalPrevBtn) modalPrevBtn.hidden = true;
    if (modalNextBtn) {
      modalNextBtn.hidden = !multi;
      modalNextBtn.classList.remove('is-hinting');
      if (multi) {
        void modalNextBtn.offsetWidth;
        modalNextBtn.classList.add('is-hinting');
      }
    }
    if (modalDots) {
      var html = '';
      if (multi) {
        for (var d = 0; d < _slideCount; d++) html += '<span' + (d === _activeSlideIdx ? ' class="is-active"' : '') + '></span>';
      }
      modalDots.innerHTML = html;
    }
    _updateGalleryNav(_activeSlideIdx || 0);
  }

  /** Show/hide arrows at the ends and move the active dot */
  function _updateGalleryNav(idx) {
    if (_slideCount < 2) return;
    if (modalPrevBtn) modalPrevBtn.hidden = idx <= 0;
    if (modalNextBtn) modalNextBtn.hidden = idx >= _slideCount - 1;
    if (modalDots) {
      var dots = modalDots.children;
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);
    }
  }

  /** Arrow click: scroll the horizontal (mobile) carousel without moving the modal */
  function _stepGallery(dir) {
    var next = Math.max(0, Math.min(_slideCount - 1, (_activeSlideIdx || 0) + dir));
    var target = document.getElementById(_getSlideId(next));
    if (!target || !modalMainCarousel) return;
    if (modalNextBtn) modalNextBtn.classList.remove('is-hinting');
    _activeSlideIdx = next;
    _syncActiveThumbs(next);
    modalMainCarousel.scrollTo({ left: target.offsetLeft, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  if (modalPrevBtn) modalPrevBtn.addEventListener('click', function () { _stepGallery(-1); });
  if (modalNextBtn) modalNextBtn.addEventListener('click', function () { _stepGallery(1); });

  /** Scroll the main carousel to a specific slide by ID — pixel-perfect, no math */
  function scrollMainToSlide(idx) {
    if (!modalMainCarousel) return;
    var target = document.getElementById(_getSlideId(idx));
    if (!target) return;

    _activeSlideIdx = idx;
    _syncActiveThumbs(idx);

    // scrollIntoView is scoped to the nearest scroll ancestor = modalMainCarousel
    // Use 'start' so the selected slide always snaps to the top of the viewport (like slide 1)
    target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---- Flavour-option helpers ---- */
  // Returns true if the option name is a flavour/flavor/taste option (not a size/pack/qty).
  // Only flavour options are shown in the modal — pack options are hidden entirely.
  function isFlavourOption(name) {
    return /flavou?r|sabor|taste|scent/i.test(name);
  }

  // Returns the index (0-based) of the first flavour option, or -1 if none.
  function flavourOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = (typeof opts[i] === 'object' && opts[i] !== null) ? (opts[i].name || '') : String(opts[i]);
      if (isFlavourOption(n)) return i;
    }
    return -1;
  }

  // Given a flavour option index and value, return the variant with the LOWEST price
  // (= single item) that has that flavour value and is available. Falls back to any variant.
  // If flavVal is null/undefined, ignore flavour filtering and just pick cheapest available.
  function pickSingleItemVariant(product, flavOptIdx, flavVal) {
    var candidates = product.variants.filter(function (v) {
      if (flavOptIdx >= 0 && flavVal != null && v['option' + (flavOptIdx + 1)] !== flavVal) return false;
      return true;
    });
    if (!candidates.length) candidates = product.variants.slice();
    // Prefer available
    var available = candidates.filter(function (v) { return v.available; });
    var pool = available.length ? available : candidates;
    // Pick lowest price (= single item)
    pool.sort(function (a, b) { return a.price - b.price; });
    return pool[0] || null;
  }

  /* Variants */
  function populateVariants(product, selectedVariant) {
    if (!modalVariants) return;

    // Hide if single variant or "Default Title" only
    if (!product.variants || product.variants.length <= 1) {
      modalVariants.innerHTML = '';
      return;
    }
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      modalVariants.innerHTML = '';
      return;
    }

    // Only render FLAVOUR options — pack/size/qty options are suppressed entirely.
    var optionNames = product.options || [];
    var html = '';
    for (var oi = 0; oi < optionNames.length; oi++) {
      var optObj = optionNames[oi];
      var optName = (typeof optObj === 'object' && optObj !== null) ? (optObj.name || '') : String(optObj);

      // Skip non-flavour options (pack size, qty, etc.)
      if (!isFlavourOption(optName)) continue;

      var selectedVal = selectedVariant ? selectedVariant['option' + (oi + 1)] : '';
      html += '<div class="bb-modal__option-group">';
      html += '<label class="bb-modal__variant-label">' + escapeHTML(optName) + ': <span>' + escapeHTML(selectedVal) + '</span></label>';
      html += '<div class="bb-modal__variant-options">';

      // Collect unique values for this option
      var seen = {};
      for (var vi = 0; vi < product.variants.length; vi++) {
        var val = product.variants[vi]['option' + (oi + 1)];
        if (seen[val]) continue;
        seen[val] = true;
        var isSelected = val === selectedVal;
        html += '<button class="bb-modal__variant-btn' + (isSelected ? ' is-selected' : '') + '" type="button" aria-pressed="' + (isSelected ? 'true' : 'false') + '" '
          + 'data-option-index="' + oi + '" data-option-value="' + escapeAttr(val) + '">'
          + escapeHTML(val) + '</button>';
      }
      html += '</div></div>';
    }
    modalVariants.innerHTML = html;
  }

  /* Price */
  function updateModalPrice(variant) {
    if (!variant) return;
    if (modalPrice) modalPrice.textContent = formatMoney(variant.price);
    if (modalComparePrice) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        modalComparePrice.textContent = formatMoney(variant.compare_at_price);
        modalComparePrice.style.display = '';
      } else {
        modalComparePrice.textContent = '';
        modalComparePrice.style.display = 'none';
      }
    }
  }

  /* Discount tag */
  function updateModalDiscountTag() {
    if (!modalDiscountTag) return;
    var tier = tiers.length > 0 ? tiers[tiers.length - 1] : null;
    if (tier) {
      modalDiscountTag.innerHTML = '<svg viewBox="0 0 13 16" fill="none"><path d="M10.2 0.17C10.42-0.06 10.77-0.06 10.98 0.17L11.73 0.96C12.59 1.86 12.59 3.32 11.73 4.22L11.2 4.78L12.02 7.92C12.23 8.72 12.01 9.57 11.45 10.16L6.78 15.07C5.92 15.97 4.54 15.97 3.68 15.07L0.64 11.88C-0.21 10.98-0.21 9.52 0.64 8.62L5.32 3.7C5.87 3.11 6.68 2.89 7.44 3.11L10.43 3.96L10.96 3.41C11.39 2.96 11.39 2.23 10.96 1.78L10.2 0.98C9.99 0.76 9.99 0.39 10.2 0.17Z" fill="currentColor"/></svg>'
        + '<span>' + tier.qty + '+ for ' + tier.pct + '% off</span>';
      modalDiscountTag.classList.add('is-visible');
    } else {
      modalDiscountTag.classList.remove('is-visible');
    }
  }

  /* Resolve variant from selected options */
  function resolveVariant(product, selectedOptions) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var oi = 0; oi < selectedOptions.length; oi++) {
        if (v['option' + (oi + 1)] !== selectedOptions[oi]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Modal event delegation */
  if (modal) {
    // Mouse-wheel on the main carousel — advance/retreat slides
    if (modalMainCarousel) {
      var _wheelTimer = null;
      modalMainCarousel.addEventListener('wheel', function (e) {
        e.preventDefault(); // stop page scroll
        clearTimeout(_wheelTimer);
        _wheelTimer = setTimeout(function () {
          if (!_modalProduct) return;
          var slides = modalMainCarousel.querySelectorAll('.bb-modal__main-slide');
          var total = slides.length;
          if (total < 2) return;
          var next = _activeSlideIdx + (e.deltaY > 0 ? 1 : -1);
          if (next < 0) next = 0;
          if (next >= total) next = total - 1;
          if (next !== _activeSlideIdx) scrollMainToSlide(next);
        }, 50);
      }, { passive: false });
    }

    // Close
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-modal-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }

      // Thumbnail click — smooth scroll main carousel to that slide
      var thumbBtn = e.target.closest('[data-thumb-idx]');
      if (thumbBtn && _modalProduct) {
        var idx = parseInt(thumbBtn.getAttribute('data-thumb-idx'), 10);
        scrollMainToSlide(idx);
        return;
      }

      // Variant option click (flavour buttons only)
      var optBtn = e.target.closest('[data-option-value]');
      if (optBtn && _modalProduct) {
        var optIdx = parseInt(optBtn.getAttribute('data-option-index'), 10);
        var optVal = optBtn.getAttribute('data-option-value');

        // Always resolve to the single item (lowest-price) variant for the chosen flavour
        var variant = pickSingleItemVariant(_modalProduct, optIdx, optVal);
        if (variant) {
          _modalVariantId = variant.id;
          populateVariants(_modalProduct, variant);
          updateModalPrice(variant);
          var selectedOption = modalVariants && modalVariants.querySelector('.bb-modal__variant-btn.is-selected');
          if (selectedOption) selectedOption.focus();

          // Update main image to variant's featured image using position (most reliable)
          if (variant.featured_image && variant.featured_image.position) {
            scrollMainToSlide(variant.featured_image.position - 1);
          } else if (variant.featured_image && variant.featured_image.src) {
            // Fallback: match by src (strip query string for reliable comparison)
            var _varSrc = variant.featured_image.src.split('?')[0];
            var imgIdx = 0;
            for (var ii = 0; ii < _modalProduct.images.length; ii++) {
              var imgSrc = typeof _modalProduct.images[ii] === 'object' ? _modalProduct.images[ii].src : _modalProduct.images[ii];
              if (imgSrc.split('?')[0] === _varSrc) { imgIdx = ii; break; }
            }
            scrollMainToSlide(imgIdx);
          }
        }
        return;
      }
    });

    // Keyboard close + focus trap
    document.addEventListener('keydown', function (e) {
      if (modal.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      if (e.key === 'Tab') {
        var focusable = Array.prototype.filter.call(
          modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (element) { return element.offsetParent !== null; }
        );
        if (!focusable.length) {
          e.preventDefault();
          if (modalTitle) modalTitle.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (document.activeElement === modalTitle) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* Add to bundle from modal */
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', function () {
      if (!_modalVariantId || !_modalHandle) return;
      if (selectedItems.length >= maxSlots) return;

      var card = grid.querySelector('.bb-card[data-product-handle="' + _modalHandle + '"]');
      if (card) {
        addToBundle(String(_modalVariantId), card);
      }
      closeModal();
    });
  }

  /* ===========================================================
     EVENT LISTENERS
     =========================================================== */
  grid.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-action="add-direct"]');
    if (addBtn) {
      e.preventDefault();
      var card = addBtn.closest('.bb-card');
      if (card) addToBundle(addBtn.getAttribute('data-variant-id'), card);
      return;
    }
    var trigger = e.target.closest('[data-variant-trigger]');
    if (trigger) {
      e.preventDefault();
      var panel = trigger.closest('[data-variant-panel]');
      if (panel) {
        var expanded = panel.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          var firstOption = panel.querySelector('.bb-card__variant-btn');
          if (firstOption) firstOption.focus();
        }
      }
      return;
    }
    var readMore = e.target.closest('[data-action="read-more"]');
    if (readMore) {
      e.preventDefault();
      var handle = readMore.closest('.bb-card').getAttribute('data-product-handle');
      if (handle) openModal(handle);
      return;
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-variant-panel]')) {
      grid.querySelectorAll('.bb-card__variant-panel.is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        var trigger = panel.querySelector('[data-variant-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (slotsContainer) {
    slotsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="remove-slot"]');
      if (!btn) return;
      var filledSlots = Array.from(slotsContainer.querySelectorAll('.bb-aside__slot.is-filled'));
      var idx = filledSlots.indexOf(btn.closest('.bb-aside__slot'));
      if (idx !== -1) removeFromBundle(idx);
    });
  }

  if (addToCartBtn) addToCartBtn.addEventListener('click', addBundleToCart);
  if (mobileAddToCartBtn) mobileAddToCartBtn.addEventListener('click', addBundleToCart);

  /* ===========================================================
     MOBILE STICKY BAR — show when ATC button scrolls out of view
     Only active on mobile (< 1024px). Uses IntersectionObserver.
     =========================================================== */
  var mobileBar = document.getElementById('bbMobileBar');

  if (mobileBar && addToCartBtn && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        // Only act on mobile viewports
        if (window.innerWidth >= 1024) {
          mobileBar.classList.remove('is-visible');
          return;
        }
        // Button is NOT visible → show sticky bar
        if (!entries[0].isIntersecting) {
          mobileBar.classList.add('is-visible');
        } else {
          mobileBar.classList.remove('is-visible');
        }
      },
      { threshold: 0 }
    );
    atcObserver.observe(addToCartBtn);

    // Also hide bar when viewport resizes to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) {
        mobileBar.classList.remove('is-visible');
      }
    });
  }

  /* ===========================================================
     INIT — load all products then render UI
     =========================================================== */
  Promise.all(handles.map(loadProduct)).then(function () {
    updateUI();
  });

})();
